// FIXME
// eslint-disable-next-line workspaces/require-dependency
import { type DefaultRootState } from '@databases/redux/default-root-state';

import {
  getDatabaseEntryOptional,
  getDatabaseFieldOptional,
  isBrokenDatabase
} from '../../database/utils';
import { getValueId } from '../../utils';
import { selectDatabaseByContentIdOptional } from '../databases/selectors';

export function selectThreadByValueIdOptional(
  state: DefaultRootState,
  { contentId, fieldId, entryId }: { contentId: string; fieldId: string; entryId: string }
) {
  const database = selectDatabaseByContentIdOptional(state, { contentId });

  if (!database || isBrokenDatabase(database)) {
    return undefined;
  }

  const entry = getDatabaseEntryOptional(database, entryId);
  const field = getDatabaseFieldOptional(database, fieldId);

  if (!entry || !field) {
    return undefined;
  }

  const commentThreads = database.commentThreads;

  const valueId = getValueId(entryId, fieldId);
  if (valueId in commentThreads) {
    return commentThreads[valueId];
  }

  return undefined;
}
export function selectUnresolvedThreadsByValueIdOptional(
  state: DefaultRootState,
  { contentId, fieldId, entryId }: { contentId: string; fieldId: string; entryId: string }
) {
  const threads = selectThreadByValueIdOptional(state, { contentId, fieldId, entryId });
  if (threads) {
    return threads.filter((thread) => !thread.isResolved);
  }

  return undefined;
}

export function selectValueIdFromThreadIdOptional(
  state: DefaultRootState,
  { contentId, threadId }: { contentId: string; threadId: string }
): string | undefined {
  const database = selectDatabaseByContentIdOptional(state, { contentId });

  if (!database || isBrokenDatabase(database)) {
    return undefined;
  }

  const commentThreads = database.commentThreads;

  for (const [key, value] of Object.entries(commentThreads)) {
    if (value.find((thread) => thread.threadId === threadId)) {
      return key;
    }
  }

  return undefined;
}

export const selectUnresolvedThreadsCommentCount = (
  threads:
    | {
        threadId: string;
        isResolved: boolean;
        commentCount: number;
        versionNumber: number;
      }[]
    | undefined
): number => {
  const totalCommentCount =
    threads?.reduce((acc, thread) => {
      return acc + thread.commentCount;
    }, 0) ?? 0;

  return totalCommentCount;
};
